import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=23f19fce&lang=pug&"
import script from "./Logout.vue?vue&type=script&lang=ts&"
export * from "./Logout.vue?vue&type=script&lang=ts&"
import style0 from "./Logout.vue?vue&type=style&index=0&id=23f19fce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports